import { createReconTheme } from "./themeTokens";

export const darkTheme = createReconTheme("dark");
